//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import React from 'react';

import classNames from 'classnames';

import DefaultTypes from '@components/DefaultTypes';
import PropTypes    from '@components/PropTypes';
import Icon         from '@stateless/atomic/Icon';
import IconType     from '@stateless/atomic/Icon/IconType';

import styles from './styles.module.scss';

const propTypes = {
    checked:        PropTypes.bool,
    noMarginBottom: PropTypes.bool,
    onClick:        PropTypes.func,
    size:           PropTypes.number,
    text:           PropTypes.string,
};

const CheckBox = ({
    checked        = false,
    noMarginBottom = false,
    onClick        = DefaultTypes.func,
    size           = 20,
    text           = '',
}) => {
    function getSize() {
        const sizeInPixel = `${size}px`;

        return {
            width:  sizeInPixel,
            height: sizeInPixel,
        };
    }

    function renderIcon() {
        if (checked) {
            return (
                <Icon
                    iconType={IconType.check}
                />
            );
        }

        return (
            <span
                style={getSize()}
                className={styles.checkBoxIconPlaceholder}
            />
        );
    }

    function renderCheckBox() {
        return (
            <div
                style={getSize()}
                className={
                    classNames(
                        styles.checkBox,
                        {
                            [styles.checkBoxChecked]: checked,
                        },
                    )
                }
            >
                {renderIcon()}
            </div>
        );
    }

    return (
        <div
            className={
                classNames(
                    styles.checkBoxWrapper,
                    {
                        [styles.checkBoxWrapperNoMarginBottom]: noMarginBottom,
                    },
                )
            }
        >
            <div
                className={styles.checkBoxWrapperClickArea}
                onClick={onClick}
            >
                {renderCheckBox()}
                <div className={styles.checkBoxWrapperLabel}>
                    {text}
                </div>
            </div>
        </div>
    );
};

CheckBox.propTypes = propTypes;

export default CheckBox;
